import type { GrassQuality } from '../world/Grass';

export type QualityLevel = 'low' | 'medium' | 'high';

export type QualitySettings = {
  level: QualityLevel;
  dprCap: number;
  msaa: number;
  grass: GrassQuality;
  godRays: boolean;
  shadowMapSize: number;
};

export const QUALITY_PRESETS: Record<QualityLevel, QualitySettings> = {
  high: {
    level: 'high',
    dprCap: 1.5,
    msaa: 4,
    grass: { density: 1.25, distance: 1, alphaToCoverage: true },
    godRays: true,
    shadowMapSize: 2048,
  },
  medium: {
    level: 'medium',
    dprCap: 1.25,
    msaa: 4,
    grass: { density: 0.85, distance: 0.85, alphaToCoverage: true },
    godRays: true,
    shadowMapSize: 1024,
  },
  low: {
    level: 'low',
    dprCap: 1.25,
    msaa: 2,
    grass: { density: 0.5, distance: 0.55, alphaToCoverage: true },
    godRays: false,
    shadowMapSize: 1024,
  },
};

export function isTouchDevice(): boolean {
  return window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
}

export function detectQuality(): QualityLevel {
  const param = new URLSearchParams(window.location.search).get('quality');
  if (param === 'low' || param === 'medium' || param === 'high') return param;
  const stored = localStorage.getItem('kaze.quality');
  if (stored === 'low' || stored === 'medium' || stored === 'high') return stored;
  if (isTouchDevice()) return 'low';
  return 'high';
}
